import React from 'react';
import { useLocation } from 'react-router';
import moment from 'moment';
import { ReportTypeEnum } from 'fragments';
import { Svg } from 'assets';


export const OrderSummary = ({ isBothReports }) => {
  const location = useLocation();
  // const navigate = useNavigate();
  const { state } = location;


  // const deleteCoupon = () => {
  //   const params = { ...state };
  //   if (params?.coupon) delete params?.coupon;
  //
  //   navigate('/order-now', { state: params });
  // };

  return (
    <div className='order-summary-wrapper'>
      <div className='order-summary-content'>
        <h2 className='order-summary-title'>Order Summary</h2>

        <p className='order-summary-text'>
          Securely pay for your FRV report. Your payment information is encrypted and protected.
        </p>

        {(state?.claimNumber || state?.address || state?.email) &&
          <div className='info_about-address_email'>
            {state?.address &&
              <div className='info_about-box'>
                <Svg.Calendar2Svg className='info_about-box_svg' />
                <p className='info_about-box_description'>
                  Date Generated:
                </p>
                <p className='info_about-box_title'>
                  {moment.utc().format('MM/DD/YYYY')}
                </p>
              </div>
            }

            {state?.claimNumber &&
              <div className='info_about-box'>
                <Svg.HashtagSvg className='info_about-box_svg' />

                <p className='info_about-box_description'>
                  Claim Number:
                </p>

                <p className='info_about-box_title'>
                  {state?.claimNumber}
                </p>
              </div>
            }

            {state?.address &&
              <div className='info_about-box'>
                <Svg.LocationSvg className='info_about-box_svg' />

                <p className='info_about-box_description'>
                  Property Address:
                </p>

                <p className='info_about-box_title'>
                  {state?.address}
                </p>
              </div>
            }

            {state?.email &&
              <div className='info_about-box'>
                <Svg.SmsTrackingSvg className='info_about-box_svg' />

                <p className='info_about-box_description'>
                  Email:
                </p>

                <p className='info_about-box_title'>
                  {state?.email}
                </p>
              </div>
            }
          </div>
        }

        <div className='order-summary-report-info-wrapper'>
          <div className='order-summary-report-info-block'>
            <p className='order-summary-report-info-text'>
              {state?.reportType === ReportTypeEnum.ALL || state?.reportType === ReportTypeEnum.FRV ? ReportTypeEnum.FRV : ReportTypeEnum.FMV} Report
            </p>

            <p className='order-summary-report-info-text' style={{ fontWeight: '700' }}>
              {state?.reportType === ReportTypeEnum.ALL || state?.reportType === ReportTypeEnum.FRV ? '$149.00' : '$99.00'}
            </p>
          </div>

          {(state?.reportType === ReportTypeEnum.ALL || isBothReports) &&
            <div className='order-summary-report-info-block'>
              <p className='order-summary-report-info-text'>
                <span style={{ color: '#0B5DCF', fontWeight: 400 }}>Add-on:</span>
                {state?.reportType === ReportTypeEnum.ALL || state?.reportType === ReportTypeEnum.FRV ? ReportTypeEnum.FMV : ReportTypeEnum.FRV}
              </p>

              <p className='order-summary-report-info-text' style={{ fontWeight: '700' }}>
                {state?.reportType === ReportTypeEnum.ALL || state?.reportType === ReportTypeEnum.FRV ? '$99.00' : '$149.00'}
              </p>
            </div>
          }
        </div>

        {(state?.reportType === ReportTypeEnum.ALL || isBothReports) &&
          <div className='order-summary-report-bundle-discount-wrapper'>
            <div className='order-summary-report-bundle-discount-block'>
              <p className='order-summary-report-bundle-discount-text'>
                Bundle Discount (FRV + FMV)
              </p>

              <p className='order-summary-report-bundle-discount'>
                -$49.00
              </p>
            </div>

            <p className='order-summary-report-bundle-discount-info-text'>
              You saved $49 with bundle pricing!
            </p>
          </div>
        }

        <div className='order-summary-report-info-wrapper' style={{ margin: 0, padding: 0, borderBottom: 'none' }}>
          <div className='order-summary-report-info-block'>
            <p className='order-summary-report-info-text'>
              Total
            </p>

            <p className='order-summary-report-info-text' style={{ fontSize: 24, fontWeight: '800' }}>
              {(state?.reportType === ReportTypeEnum.ALL || isBothReports) ? '$199.00' : state?.reportType === ReportTypeEnum.FMV ? '$99' : '$149'}
            </p>
          </div>
        </div>

        {/*{state?.coupon?.id &&*/}
        {/*  <div className='coupon-wrapper'>*/}
        {/*    <div className='coupon-info-wrapper'>*/}
        {/*      <p className='coupon-info-text'>*/}
        {/*        Coupon Applied <span style={{ fontSize: '14px', fontWeight: 400 }}>(100% off)</span>*/}
        {/*      </p>*/}

        {/*      <p className='coupon-info-count'>*/}
        {/*        -$149.00*/}
        {/*      </p>*/}
        {/*    </div>*/}

        {/*    <div className='coupon-cards-wrapper'>*/}

        {/*      <div className='coupon-card'>*/}
        {/*        <Svg.CouponSvg className='coupon-card-svg' />*/}

        {/*        <p className='coupon-card-text'>*/}
        {/*          Coupon {state?.coupon?.code}*/}
        {/*        </p>*/}

        {/*        <Svg.Close className='coupon-card-delete-svg' onClick={deleteCoupon} />*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*}*/}
      </div>
    </div>
  );
};
